import { getFullTranslations } from './util';

export const frTranslationMessages = getFullTranslations('defaultMessage');
